export default "__VITE_ASSET__DzXUJxsf__"